import React from 'react';
import { connect } from 'react-redux';
import { newCohortFromDataset } from '@/cohorts/actions';
import DatasetToolsMenu from './DatasetToolsMenu';
import datasetStatus from '../status/helper';
import DatasetCardItemWrapper from '../components/DatasetCardItemWrapper';
import { showDatasetConditions } from '../conditions/actions';

const DatasetCardItem = ({
  accessRequestAllowed,
  accessRequestSupported,
  accessRequestUnsupportedReasons,
  cohortAllowed,
  cohortSupported,
  cohortUnsupportedReasons,
  dataset,
  hasConditions,
  newCohort,
  newCohortCode,
  newRequestCode,
  onCheckBoxClick,
  showConditions,
  showStatus,
  showTools,
  single,
  upward,
}) => (
  <DatasetCardItemWrapper
    accessRequestAllowed={accessRequestAllowed}
    accessRequestSupported={accessRequestSupported}
    accessRequestUnsupportedReasons={accessRequestUnsupportedReasons}
    cohortAllowed={cohortAllowed}
    cohortSupported={cohortSupported}
    cohortUnsupportedReasons={cohortUnsupportedReasons}
    dataset={dataset}
    hasConditions={hasConditions}
    newCohort={newCohort}
    newCohortCode={newCohortCode}
    newRequestCode={newRequestCode}
    onCheckBoxClick={onCheckBoxClick}
    showConditions={showConditions}
    showStatus={showStatus}
    single={single}
  >
    {showTools && (<DatasetToolsMenu iconSize="large" upward={upward} dataset={dataset} listItem />)}
  </DatasetCardItemWrapper>
);

const mapStateToProps = ({
  auth: { role },
  cohorts: { newCohortCode },
  requests: { newRequestCode },
}, { dataset }) => ({
  newCohortCode,
  newRequestCode,
  ...datasetStatus(role, dataset, dataset.primary_dictionary),
});

const mapDispatchToProps = {
  newCohort: (code, datasetCode, dictionaryCode) => (
    newCohortFromDataset(code, 'open', datasetCode, [dictionaryCode])),
  showConditions: showDatasetConditions,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetCardItem);
